import Vue from 'vue'
import { omit } from 'lodash'
import inform from '@/services/inform'

// State
const state = {
  isLoading: false,
  data: null,
  isSaving: false,
  selectedSlogan: null
}

// Mutations
const fetchSlogansRequest = 'fetchSlogansRequest'
const fetchSlogansResponse = 'fetchSlogansResponse'
const saveSloganRequest = 'saveSloganRequest'
const saveSloganResponse = 'saveSloganResponse'
export const selectSlogan = 'selectSlogan'
export const unselectSlogan = 'unselectSlogan'
const deleteSloganRequest = 'deleteSloganRequest'
const deleteSloganResponse = 'deleteSloganResponse'

const mutations = {
  [fetchSlogansRequest] (state) {
    state.isLoading = true
  },
  [fetchSlogansResponse] (state, slogans) {
    state.isLoading = false
    state.data = slogans
  },
  [saveSloganRequest] (state) {
    state.isSaving = true
  },
  [saveSloganResponse] (state, slogan) {
    state.isSaving = false
    if (!slogan) {
      return
    }
    const index = state.data.findIndex(({ id }) => id === slogan.id)
    if (index > -1) {
      state.data = [
        ...state.data.slice(0, index),
        { ...state.data[index], ...slogan },
        ...state.data.slice(index + 1)
      ]
    } else {
      state.data = [...state.data, slogan]
    }
  },
  [selectSlogan] (state, slogan) {
    state.selectedSlogan = slogan
  },
  [unselectSlogan] (state) {
    state.selectedUser = null
  },
  [deleteSloganRequest] (state, slogan) {
    state.isSaving = true
  },
  [deleteSloganResponse] (state, slogan) {
    state.isSaving = false
    if (slogan) {
      state.data = state.data.filter(({ id }) => id !== slogan.id)
    }
  }
}

// Actions
export const fetchSlogans = 'fetchSlogans'
export const saveSlogan = 'saveSlogan'
export const deleteSlogan = 'deleteSlogan'

const actions = {
  [fetchSlogans]: ({ commit, dispatch }) => {
    commit(fetchSlogansRequest)
    return Vue.http.get(`${SERVER_URL}/slogans`).then(({ data: slogans }) => {
      commit(fetchSlogansResponse, slogans)
    })
  },
  [saveSlogan]: ({ commit }, slogan) => {
    commit(saveSloganRequest)

    let request
    // UPDATE
    if (slogan.id) {
      request = Vue.http.put(
        `${SERVER_URL}/slogans/${slogan.id}`,
        omit(slogan, ['password', 'id'])
      )
    } else {
      // CREATE
      request = Vue.http.post(`${SERVER_URL}/slogans`, slogan)
    }

    return request
      .then(({ data: slogan }) => {
        commit(saveSloganResponse, slogan)
        return slogan
      })
      .catch(() => {
        commit(saveSloganResponse, null)
        return null
      })
  },
  [deleteSlogan] ({ commit }, slogan) {
    commit(deleteSloganRequest, slogan)
    return Vue.http
      .delete(`${SERVER_URL}/slogans/${slogan.id}`)
      .then(() => {
        inform(`Der Slogan "${slogan.text}" wurde erfolgreich gelöscht`)
        commit(deleteSloganResponse, slogan)
      })
      .catch(() => {
        commit(deleteSloganResponse, null)
      })
  }
}

export default {
  state,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/slogans.js